import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

export const EmptyReducer = (state = null) => state
export default history =>
  combineReducers({
    router: connectRouter(history),
    empty: EmptyReducer
  })
